import { useContext } from 'react';
import {
 AppContext,
 MainContext,
 CompanyContext,
 ProjectContext,
 ArticleContext,
 LoanContext,
 WhatsAppContext,
 OfferContext,
 OrderContext,
 InputContext,
 OuputContext,
 PaymentContext,
 TelegramContext
} from './Context';

export const contextApp = () => useContext(AppContext);
export const contextMain = () => useContext(MainContext);
export const contextCompany = () => useContext(CompanyContext);
export const contextProject = () => useContext(ProjectContext);
export const contextArticle = () => useContext(ArticleContext);
export const contextOrder = () => useContext(OrderContext);
export const contextInput = () => useContext(InputContext);
export const contextOuput = () => useContext(OuputContext);
export const contextOffer = () => useContext(OfferContext);
export const contextLoan = () => useContext(LoanContext);
export const contextWhatsApp = () => useContext(WhatsAppContext);
export const contextPayment = () => useContext(PaymentContext);
export const contextTelegram = () => useContext(TelegramContext);
/* export const contextSetting = () => useContext(SettingContext);
export const contextProject = () => useContext(ProjectContext); */

//const { recoveryMail } = Auth();
